<template>
  <div class="common-home-content common-home-content-pb space_pl space_pr" v-show="show">
    <p class="question-title">问题标题</p>
    <div class="question-name">
      <input type="text" v-model="question_value" placeholder="请输入问题">
    </div>
    <p class="question-title question-type">问题类型</p>
    <ul class="question-type-ul clearfix">
      <li class="fl radio" @click="handleChangeType(1)">
        <label :class="question_type == 1?'actived':''"></label>
        单选题
      </li>
      <li class="fl checkbox" @click="handleChangeType(2)">
        <label :class="question_type == 2?'actived':''"></label>
        多选题
      </li>
      <li class="fl answer" @click="handleChangeType(3)">
        <label :class="question_type == 3?'actived':''"></label>
        简答题
      </li>
    </ul>
    <div class="answer-textarea" v-if="question_type == 3"></div>
    <ul class="option-question-ul" v-else>
      <li v-for="(child, index) in options" :key="index" :class="child.type != 1?'option':'add'">
        <label v-if="child.type != 1" @click="handleDeleteOption(index)"></label>
        <label @click="handleAddOption(index)" v-else></label>
        <input type="text" v-model="child.content" placeholder="输入选项内容" @input="onInput" v-if="child.type != 1">
        <input type="text" v-model="add_value" @input="handleOptionInput" placeholder="输入选项内容" v-else>
      </li>
    </ul>
    <div class="fixed-button">
      <button @click="saveQuestion">确认提交</button>
    </div>
  </div>
</template>
<script>
import http from '../../util/heraApiConfig'
export default {
  data() {
    return {
      show: false,
      title: '创建问题',
      local_survey_question: {},
      doctor_id: 1,
      question_value: '',
      token: '',
      question_type: 1,
      add_value: '',
      sheet_id: '',
      question_id: '',
      question_status: 0,
      question_index: 0,
      questions: [],
      options: [{'content': '', 'type': 1}],
      isApp:'',
      platform_type:'',
    };
  },
  metaInfo(){
    return {title: this.title};
  },
  created() {
    let bridge = window.WebViewJavascriptBridge;
    this.show = true;
    this.isApp = this.$appUtils.isApp();
    if (this.isApp == "IOS") {
      bridge.callHandler("showTrBtn", {'name': ""}, (response) => {
      });
      bridge.callHandler("getUserInfo", "", (response) => {
        this.token = response.token;
        this.doctor_id = response.doctor_id;
        this.platform_type = response.platform_type;
      });
      bridge.registerHandler('saveQuestion', (data, responseCallback)=> {
        this.saveQuestion()
      });
      bridge.registerHandler('pageback', (data, responseCallback)=> {
        this.pageback()
      });
    } else if (this.isApp == "android") {
      this.$appUtils.showAppTrBtn({'name': ""});
      var user_info = this.$appUtils.appData();
      if (user_info) {
        this.token = user_info.token;
        this.doctor_id = user_info.doctor_id;
        this.platform_type = user_info.platform_type;
      }
    }
    this.local_survey_question = JSON.parse(localStorage.getItem('local_survey_question'));
    this.questions = this.local_survey_question['questions'];
    if(this.local_survey_question['index'] != undefined){
      this.title = '编辑问题';
      this.question_index = this.local_survey_question['index'];
      this.question_id = this.questions[this.question_index]['question_id'];
      this.question_value = this.questions[this.question_index]['content'];
      this.question_type = this.questions[this.question_index]['type'];
      if(this.question_type != 3){
        this.options = this.questions[this.question_index]['options'].concat(this.options);
      }
      if(this.questions[this.question_index]['status']){
        this.question_status = this.questions[this.question_index]['status'];
        this.sheet_id = this.local_survey_question['sheet_id'];
      }
    }
    this.show = true;
    window.appTrBtnClick = ()=> this.saveQuestion();
    window.appBack = ()=> this.pageback();
  },
  mounted() {
  },
  methods: {
    getDate() {
      let that = this;
      let params = {
          doctor_id: that.doctor_id
      }
      http.get("/surveys/surveys"+"?platform_type="+that.platform_type, {params: params,
        headers: {
            "Authorization": that.token
        }
      }).then(function(res) {
          that.system_surveys = res.data.data.system_surveys;
          that.surveys = res.data.data.surveys;
          that.show = true;
      });
    },
    onInput(){
        this.$forceUpdate();
    },
    handleChangeType(index){
      if(this.question_type != index){
        this.question_type = index;
      }
    },
    handleOptionInput(e){
      let value = e.target.value;
      if(value){
        let index = this.options.length - 1;
        this.options.splice(index, 0, {'content': value});
        this.add_value = '';
      }
    },
    handleDeleteOption(index){
      let that = this;
      that.$dialog.alert({
              title: "提示", //加上标题
              message: "确定要删除该选项吗？", //改变弹出框的内容
              showCancelButton: true //展示取水按钮
      })
      .then(() => { //点击确认按钮后的调用
              that.options.splice(index, 1);
      })
      .catch(() => { //点击取消按钮后的调用
      })
    },
    handleAddOption(index){
      this.options.splice(index, 0, {'content': ''});
    },
    saveQuestion(){
      let that = this;
      let filter_options = []
      for(let i = 0; i < that.options.length; i++){
        if(that.options[i]['content'] && that.options[i]['type'] != 1){
          filter_options.push(that.options[i])
        }
      }
      if(!that.question_value){
        that.$toast('请输入问题')
      }else if(that.question_type != 3 && filter_options.length == 0){
        that.$toast('请添加选项内容')
      }else{
        let params = {
            doctor_id: that.doctor_id,
            content: that.question_value,
            type: that.question_type,
          platform_type: that.platform_type
        }
        // alert(JSON.stringify(params))
        if(that.question_type != 3){
          params['options'] = JSON.stringify(filter_options);
        }
        if(that.local_survey_question['index'] == undefined){
          http.post("/surveys/question", params ,{headers: {"Authorization": that.token }
          }).then(function(res) {
              if(res.data.status_code == 200){
                let obj = {
                  'question_id': res.data.data.id,
                  'content': that.question_value,
                  'type': that.question_type,
                  'status': res.data.data.status
                }
                if(that.question_type != 3){
                  obj['options'] = filter_options;
                }
                that.questions.push(obj)
                that.local_survey_question['questions'] = that.questions;
                localStorage.setItem('local_survey_question', JSON.stringify(that.local_survey_question ));
                localStorage.removeItem('is_new_build_survey_status');
                that.pageback();
              }
          });
        }else{
          params['question_id'] = that.question_id;
          if(that.question_status){
            params['sheet_id'] = that.sheet_id;
            http.post("/surveys/used/option", params ,{headers: {"Authorization": that.token }
            }).then(function(res) {
                if(res.data.status_code == 200){
                  let obj = {
                    'question_id': res.data.data.id,
                    'content': that.question_value,
                    'type': that.question_type,
                    'status': res.data.data.status
                  }
                  if(that.question_type != 3){
                    obj['options'] = filter_options;
                  }
                  that.questions.splice(that.question_index, 1);
                  that.questions.splice(that.question_index, 0, obj);
                  that.local_survey_question['questions'] = that.questions;
                  localStorage.setItem('local_survey_question', JSON.stringify(that.local_survey_question ));
                  localStorage.removeItem('is_new_build_survey_status');
                  that.pageback();
                }
            });
          }else{
            http.put("/surveys/question", params ,{headers: {"Authorization": that.token }
            }).then(function(res) {
                if(res.data.status_code == 200){
                  let obj = {
                    'question_id': res.data.data.id,
                    'content': that.question_value,
                    'type': that.question_type,
                    'status': res.data.data.status
                  }
                  if(that.question_type != 3){
                    obj['options'] = filter_options;
                  }
                  that.questions.splice(that.question_index, 1);
                  that.questions.splice(that.question_index, 0, obj);
                  that.local_survey_question['questions'] = that.questions;
                  localStorage.setItem('local_survey_question', JSON.stringify(that.local_survey_question ));
                  localStorage.removeItem('is_new_build_survey_status');
                  that.pageback();
                }
            });
          }
        }
      }
    },
    pageback(){
        if(localStorage.getItem('is_new_build_survey_status')){
          window.history.go(-2);
        }else{
          window.history.back();
        }
        return true;
    }
  },
};
</script>

<style lang="scss" scoped>
.common-home-content-pb{
  padding-bottom: 52px;
}
.question-title{
  padding-top: 20px;
  line-height:16px;
  font-size:16px;
  font-family:PingFang-SC-Bold;
  font-weight:bold;
  color:rgba(51,51,51,1);
}
.question-type{
  margin-top: 26px;
}
.question-name{
  margin-top: 15px;
  width: 100%;
  box-sizing: border-box;
  & > input{
    width: 100%;
    height: 36px;
    padding: 9px 15px 10px;
    font-size:15px;
    line-height: 15px;
    font-family:PingFang-SC-Medium;
    font-weight:500;
    color:rgba(51,51,51,1);
    box-sizing: border-box;
    background:transparent;
    border:none;
    box-shadow: 0px 2px 5px 1px rgba(35, 24, 21, 0.15);
    border-radius: 5px;
  }
}
.question-type-ul{
  margin-top: 15px;
  margin-bottom: 20px;
  width: 100%;
  box-sizing: border-box;
  & > li{
    margin-right: 40px;
    display: inline-block;
    box-sizing: border-box;
    padding-left: 25px;
    height:16px;
    line-height: 16px;
    font-size:16px;
    font-family:PingFang-SC-Medium;
    font-weight:500;
    color:rgba(52,52,52,1);
    position: relative;
    & > label{
      display: block;
      width: 16px;
      height: 16px;
      border:1px solid rgba(204,204,204,1);
      border-radius:50%;
      margin: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
    }
    .actived{
      border:1px solid rgba(172,76,56,1);
    }
    .actived::after{
      content: '';
      display: block;
      width: 12px;
      height: 12px;
      background-color: rgba(172,76,56,1);
      border-radius:50%;
      margin: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
  .answer{
    margin-right: 0;
  }
}
.option-question-ul{
  width: 100%;
  box-sizing: border-box;
  & > li{
    margin-bottom: 10px;
    width: 100%;
    box-sizing: border-box;
    position: relative;
    & > input{
      width: 100%;
      height: 36px;
      padding: 9px 15px 10px;
      font-size:15px;
      line-height: 15px;
      font-family:PingFang-SC-Medium;
      font-weight:500;
      color:rgba(51,51,51,1);
      box-sizing: border-box;
      background:transparent;
      border:none;
      box-shadow: 0px 2px 5px 1px rgba(35, 24, 21, 0.15);
      border-radius: 5px;
    }
  }
  .option{
    padding-left: 35px;
    & > label{
      display: block;
      width: 18px;
      height: 18px;
      background: url('../../assets/images/survey/question_del.png') no-repeat;
      background: none\9;
      background-size: 18px 18px;
      margin: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
    }
  }
  .add{
    padding-left: 35px;
    & > label{
      display: block;
      width: 18px;
      height: 18px;
      background: url('../../assets/images/survey/question_add.png') no-repeat;
      background: none\9;
      background-size: 18px 18px;
      margin: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
    }
  }
}
.answer-textarea{
  width: 100%;
  height:90px;
  box-sizing: border-box;
  border:1px solid rgba(204,204,204,1);
  border-radius:5px;
}
.fixed-button{
  width: 100%;
  box-sizing: border-box;
  padding: 3px 15px;
  position:fixed;
  left: 0;
  bottom: 0;
  & > button{
    display: block;
    width: 100%;
    box-sizing: border-box;
    line-height: 43px;
    font-size:17px;
    font-family: PingFang-SC-Medium;
    font-weight:500;
    color:rgba(255,255,255,1);
    text-align: center;
    background:rgba(172,76,56,1);
    border-radius:4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/surveys/bulidquestion.vue